import { dateToUtc } from '../../functions';

export default function getDateDaysFromNow(days: number) {
  const dayInMillis = 24 * 60 * 60 * 1000;
  return dateToUtc(new Date(Date.now() + (days * dayInMillis)));
}
